import { Component, createRef, RefObject, CSSProperties } from 'react';
import { headParts, rightAntlerParts, leftAnterParts } from './svgParts';
import componentLocationToTop from '../../util/componentLocation';

interface SplittingDeerState {
    scrollPosition: number;
    [key: string]: number | string;
}

class SplittingDeer extends Component<Record<string, never>, SplittingDeerState> {
    private deerContainer: RefObject<HTMLDivElement | null> = createRef();

    state: SplittingDeerState = { scrollPosition: 0 };

    componentDidMount() {
        for (let i = 0; i <= 47; i++) {
            const randomNumber = Math.random() * 10;
            this.setState({ [`${i}`]: randomNumber < 5 ? randomNumber * 2 : randomNumber });
            this.setState({ [`${i}direction`]: Math.random() > 0.5 ? '' : '-' });
        }
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const distanceFromTop = componentLocationToTop(this.deerContainer);
        if (distanceFromTop !== null && distanceFromTop * -1 >= 0) {
            this.setState({ scrollPosition: distanceFromTop * -1 });
        }
    };

    private partStyle(index: number): CSSProperties {
        const pos = this.state.scrollPosition;
        const scale = (this.state[`${index}`] as number) ?? 0;
        const dir = (this.state[`${index}direction`] as string) ?? '';
        return {
            transform: `rotate(${pos / 10 * scale / 5}deg) translateX(${dir}${parseInt(`${pos * scale / 4}`)}px)`,
            opacity: `${1 - pos / 500}`,
        };
    }

    private headStyle(index: number): CSSProperties {
        const pos = this.state.scrollPosition;
        const scale = (this.state[`${index}`] as number) ?? 0;
        const dir = (this.state[`${index}direction`] as string) ?? '';
        return {
            transform: `rotate(${pos / 10 * scale / 5}deg) translateY(${-parseInt(`${pos * scale / 4}`)}px) translateX(${dir}${parseInt(`${pos * scale / 4}`)}px)`,
            opacity: `${1 - pos / 500}`,
        };
    }

    renderLeftAntlerParts() {
        return leftAnterParts.map((part, i) => (
            <g key={i} style={this.partStyle(i + 15)}>{part}</g>
        ));
    }

    renderRightAntlerParts() {
        return rightAntlerParts.map((part, i) => (
            <g key={i} style={this.partStyle(i + 30)}>{part}</g>
        ));
    }

    renderHeadParts() {
        return headParts.map((part, i) => (
            <g key={i} style={this.headStyle(i)}>{part}</g>
        ));
    }

    autoScroll() {
        window.scrollBy({
            top: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            left: 0,
            behavior: 'smooth',
        });
    }

    render() {
        return (
            <div className='logoSplitContainer' ref={this.deerContainer}>
                <svg
                    x='0px'
                    y='0px'
                    width='100%'
                    height='100%'
                    viewBox='0 0 478 454.667'
                    style={{ enableBackground: 'new 0 0 478 454.667' } as CSSProperties}
                >
                    {this.renderHeadParts()}
                    {this.renderLeftAntlerParts()}
                    {this.renderRightAntlerParts()}
                </svg>
                {this.state.scrollPosition === 0 && (
                    <i className='fas fa-angle-double-down' onClick={() => this.autoScroll()} />
                )}
            </div>
        );
    }
}

export default SplittingDeer;
